import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { RtButtonVariant } from '../../common/button-new/button.types';
import { OverlayPosition } from '../../core/overlay/overlay-directives';
import { RtStatefulComponent } from '../../utils/rt-stateful-component';

type State = {
  dropdownOpened: boolean;
};

@Component({
  templateUrl: './bulk-select.component.html',
  styleUrls: ['./bulk-select.component.less'],
  selector: 'rt-bulk-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.active]': 'active',
  },
})
export class BulkSelectComponent extends RtStatefulComponent<State> {
  @Input() public allSelected: boolean = false;
  @Input() public selectedCount: number = 0;
  @Input() public disabled: boolean = false;
  @Input() public active: boolean = false;
  @Input() public indeterminateState: boolean = false;
  @Input() public variant: Extract<RtButtonVariant, 'secondary' | 'outlined'> = 'secondary';

  // emits true if select all, false if select none
  @Output() public select: EventEmitter<boolean> = new EventEmitter();

  public readonly OverlayPosition: typeof OverlayPosition = OverlayPosition;

  constructor(protected cdRef: ChangeDetectorRef) {
    super(cdRef);
    this.createState({
      dropdownOpened: false,
    });
  }

  public toggleDropdown(dropdownOpened: boolean = !this.state.dropdownOpened): void {
    this.setState({ dropdownOpened });
  }
}
